import { useContext, useCallback, createContext } from 'react';
import type { WorkspaceMembersResponseT } from '@mentimeter/http-clients';

interface InvalidationContext {
  invalidate: () => Promise<WorkspaceMembersResponseT[] | undefined>;
}
const InvalidationContext = createContext<InvalidationContext | null>(null);

export function InvalidationContextProvider({
  invalidate,
  children,
}: {
  invalidate: () => Promise<WorkspaceMembersResponseT[] | undefined>;
  children: React.ReactNode;
}) {
  return (
    <InvalidationContext.Provider value={{ invalidate }}>
      {children}
    </InvalidationContext.Provider>
  );
}

export function useInvalidateWorkspaceMembersPaginated() {
  const context = useContext(InvalidationContext);
  return useCallback(() => {
    context?.invalidate();
  }, [context]);
}
